
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';

// const News = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const API_BASE_URL = 'http://localhost:5000/api';

//   useEffect(() => {
//     fetchNews();
//   }, [currentPage]);

//   const fetchNews = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/news?page=${currentPage}&limit=10`
//       );
      
//       if (response.data.success) {
//         setNews(response.data.data);
//         setTotalPages(response.data.totalPages);
//       }
//     } catch (err) {
//       console.error('Error fetching news:', err);
//       setError('Failed to load news');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     try {
//       const date = new Date(dateString);
//       const day = date.getDate();
//       const month = date.toLocaleString('default', { month: 'short' });
//       const year = date.getFullYear();
//       return `${day} ${month} ${year}`;
//     } catch {
//       return dateString;
//     }
//   };

//   const styles = {
//     container: {
//       maxWidth: '1000px',
//       margin: '0 auto',
//       padding: '40px 20px',
//       fontFamily: 'Cambria, serif',
//       backgroundColor: '#ffffff',
//     },
    
//     // Header
//     header: {
//       marginBottom: '40px',
//       borderBottom: '2px solid #447793',
//       paddingBottom: '20px',
//     },
//     title: {
//       fontSize: '2.5rem',
//       fontWeight: '800',
//       color: '#123249',
//       marginBottom: '10px',
//     },
//     subtitle: {
//       fontSize: '1.1rem',
//       color: '#2D5A74',
//     },
    
//     // News List - 1 column
//     newsList: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '30px',
//       marginBottom: '40px',
//     },
    
//     // News Card
//     newsCard: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       overflow: 'hidden',
//       boxShadow: '0 3px 10px rgba(6, 18, 33, 0.08)',
//       border: '1px solid #DDE8ED',
//       transition: 'all 0.3s ease',
//       cursor: 'pointer',
//       display: 'flex',
//       flexDirection: 'column',
//     },
    
//     // Image Container
//     imageContainer: {
//       width: '100%',
//       height: '300px',
//       overflow: 'hidden',
//       backgroundColor: '#DDE8ED',
//       position: 'relative',
//     },
//     newsImage: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'transform 0.5s ease',
//     },
//     dateOverlay: {
//       position: 'absolute',
//       top: '20px',
//       right: '20px',
//       backgroundColor: '#447793',
//       color: 'white',
//       padding: '8px 15px',
//       borderRadius: '25px',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       zIndex: 2,
//     },
    
//     // Content
//     newsContent: {
//       padding: '25px',
//     },
//     source: {
//       color: '#447793',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       marginBottom: '10px',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '5px',
//     },
//     newsTitle: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: '10px',
//       lineHeight: '1.4',
//     },
//     headline: {
//       fontSize: '1.1rem',
//       color: '#2D5A74',
//       marginBottom: '15px',
//       fontStyle: 'italic',
//     },
//     summary: {
//       color: '#2D5A74',
//       fontSize: '1rem',
//       lineHeight: '1.6',
//       marginBottom: '20px',
//     },
//     metaInfo: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '20px',
//       color: '#2D5A74',
//       fontSize: '0.9rem',
//       borderTop: '1px solid #DDE8ED',
//       paddingTop: '15px',
//       marginTop: '15px',
//     },
//     readMore: {
//       color: '#447793',
//       fontWeight: '600',
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '5px',
//       textDecoration: 'none',
//     },
    
//     // Pagination
//     pagination: {
//       display: 'flex',
//       justifyContent: 'center',
//       gap: '10px',
//       marginTop: '40px',
//     },
//     pageButton: {
//       padding: '10px 16px',
//       borderRadius: '8px',
//       border: '1px solid #DDE8ED',
//       backgroundColor: 'white',
//       color: '#123249',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       minWidth: '40px',
//     },
//     pageButtonActive: {
//       backgroundColor: '#447793',
//       color: 'white',
//       borderColor: '#447793',
//     },
//     pageButtonDisabled: {
//       opacity: 0.5,
//       cursor: 'not-allowed',
//     },
    
//     // Loading State
//     loadingContainer: {
//       textAlign: 'center',
//       padding: '60px 20px',
//     },
//     loader: {
//       border: '4px solid #DDE8ED',
//       borderTop: '4px solid #447793',
//       borderRadius: '50%',
//       width: '50px',
//       height: '50px',
//       animation: 'spin 1s linear infinite',
//       margin: '0 auto 20px',
//     },
    
//     // Empty State
//     emptyState: {
//       textAlign: 'center',
//       padding: '60px 20px',
//       backgroundColor: '#DDE8ED',
//       borderRadius: '15px',
//       color: '#123249',
//     },
//   };

//   const keyframes = `
//     @keyframes spin {
//       0% { transform: rotate(0deg); }
//       100% { transform: rotate(360deg); }
//     }
//   `;

//   if (loading && news.length === 0) {
//     return (
//       <div style={styles.container}>
//         <style>{keyframes}</style>
//         <div style={styles.loadingContainer}>
//           <div style={styles.loader}></div>
//           <p>Loading news...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <style>{keyframes}</style>
      
//       {/* Header */}
//       <div style={styles.header}>
//         <h1 style={styles.title}>📰 Latest News</h1>
//         <p style={styles.subtitle}>
//           Stay updated with the latest developments in solar energy and renewable power
//         </p>
//       </div>

//       {/* News List - 1 Column */}
//       {news.length === 0 ? (
//         <div style={styles.emptyState}>
//           <div style={{ fontSize: '3rem', marginBottom: '15px' }}>📭</div>
//           <h3>No news articles found</h3>
//           <p>Check back later for updates</p>
//         </div>
//       ) : (
//         <div style={styles.newsList}>
//           {news.map((item) => (
//             <Link
//               key={item._id}
//               to={`/news/${item._id}`}
//               style={{ textDecoration: 'none' }}
//             >
//               <div
//                 style={styles.newsCard}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-5px)';
//                   e.currentTarget.style.boxShadow = '0 10px 25px rgba(68, 119, 147, 0.15)';
                  
//                   const img = e.currentTarget.querySelector('.news-image');
//                   if (img) img.style.transform = 'scale(1.05)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0)';
//                   e.currentTarget.style.boxShadow = '0 3px 10px rgba(6, 18, 33, 0.08)';
                  
//                   const img = e.currentTarget.querySelector('.news-image');
//                   if (img) img.style.transform = 'scale(1)';
//                 }}
//               >
//                 {/* Image */}
//                 <div style={styles.imageContainer}>
//                   <div style={styles.dateOverlay}>
//                     {formatDate(item.date)}
//                   </div>
//                   <img
//                     src={item.imageUrl || item.image || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=300&fit=crop'}
//                     alt={item.title}
//                     style={styles.newsImage}
//                     className="news-image"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=300&fit=crop';
//                     }}
//                   />
//                 </div>

//                 {/* Content */}
//                 <div style={styles.newsContent}>
//                   {item.source && (
//                     <div style={styles.source}>
//                       <span>📰</span>
//                       {item.source}
//                       {item.sourceLocation && `, ${item.sourceLocation}`}
//                     </div>
//                   )}
                  
//                   <h2 style={styles.newsTitle}>{item.title}</h2>
                  
//                   {item.headline && (
//                     <div style={styles.headline}>{item.headline}</div>
//                   )}
                  
//                   <p style={styles.summary}>{item.summary}</p>
                  
//                   <div style={styles.metaInfo}>
//                     {item.author && (
//                       <span>✍️ {item.author}</span>
//                     )}
//                     <span>👁️ {item.views || 0} views</span>
//                     <span style={styles.readMore}>
//                       Read full article →
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       )}

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div style={styles.pagination}>
//           <button
//             style={{
//               ...styles.pageButton,
//               ...(currentPage === 1 ? styles.pageButtonDisabled : {}),
//             }}
//             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//             disabled={currentPage === 1}
//             onMouseEnter={(e) => {
//               if (currentPage !== 1) {
//                 e.currentTarget.style.backgroundColor = '#447793';
//                 e.currentTarget.style.color = 'white';
//               }
//             }}
//             onMouseLeave={(e) => {
//               if (currentPage !== 1) {
//                 e.currentTarget.style.backgroundColor = 'white';
//                 e.currentTarget.style.color = '#123249';
//               }
//             }}
//           >
//             ← Previous
//           </button>
          
//           <span style={{ padding: '10px 20px', color: '#123249' }}>
//             Page {currentPage} of {totalPages}
//           </span>
          
//           <button
//             style={{
//               ...styles.pageButton,
//               ...(currentPage === totalPages ? styles.pageButtonDisabled : {}),
//             }}
//             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//             disabled={currentPage === totalPages}
//             onMouseEnter={(e) => {
//               if (currentPage !== totalPages) {
//                 e.currentTarget.style.backgroundColor = '#447793';
//                 e.currentTarget.style.color = 'white';
//               }
//             }}
//             onMouseLeave={(e) => {
//               if (currentPage !== totalPages) {
//                 e.currentTarget.style.backgroundColor = 'white';
//                 e.currentTarget.style.color = '#123249';
//               }
//             }}
//           >
//             Next →
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default News;













import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const API_BASE_URL = 'http://localhost:5000/api';

  useEffect(() => {
    fetchNews();
  }, [currentPage]);

  const fetchNews = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/news?page=${currentPage}&limit=9` // Changed to 9 for 3x3 grid
      );
      
      if (response.data.success) {
        setNews(response.data.data);
        setTotalPages(response.data.totalPages);
      }
    } catch (err) {
      console.error('Error fetching news:', err);
      setError('Failed to load news');
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    } catch {
      return dateString;
    }
  };

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'Cambria, serif',
      backgroundColor: '#ffffff',
    },
    
    // Header
    header: {
      marginBottom: '40px',
      borderBottom: '2px solid #447793',
      paddingBottom: '20px',
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '800',
      color: '#123249',
      marginBottom: '10px',
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#2D5A74',
    },
    
    // News Grid - 3 columns
    newsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '25px',
      marginBottom: '40px',
    },
    
    // News Card
    newsCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 3px 10px rgba(6, 18, 33, 0.08)',
      border: '1px solid #DDE8ED',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    
    // Image Container
    imageContainer: {
      width: '100%',
      height: '180px', // Reduced height for grid layout
      overflow: 'hidden',
      backgroundColor: '#DDE8ED',
      position: 'relative',
    },
    newsImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.5s ease',
    },
    dateOverlay: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      backgroundColor: '#447793',
      color: 'white',
      padding: '5px 12px',
      borderRadius: '20px',
      fontSize: '0.8rem',
      fontWeight: '600',
      zIndex: 2,
    },
    
    // Content
    newsContent: {
      padding: '18px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    source: {
      color: '#447793',
      fontSize: '0.8rem',
      fontWeight: '600',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
    newsTitle: {
      fontSize: '1.2rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: '8px',
      lineHeight: '1.4',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
    headline: {
      fontSize: '0.9rem',
      color: '#2D5A74',
      marginBottom: '10px',
      fontStyle: 'italic',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
    summary: {
      color: '#2D5A74',
      fontSize: '0.9rem',
      lineHeight: '1.5',
      marginBottom: '15px',
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      flex: 1,
    },
    metaInfo: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#2D5A74',
      fontSize: '0.8rem',
      borderTop: '1px solid #DDE8ED',
      paddingTop: '12px',
      marginTop: 'auto',
    },
    readMore: {
      color: '#447793',
      fontWeight: '600',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      textDecoration: 'none',
      fontSize: '0.85rem',
    },
    
    // Pagination
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      marginTop: '40px',
    },
    pageButton: {
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #DDE8ED',
      backgroundColor: 'white',
      color: '#123249',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      minWidth: '40px',
    },
    pageButtonActive: {
      backgroundColor: '#447793',
      color: 'white',
      borderColor: '#447793',
    },
    pageButtonDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    
    // Loading State
    loadingContainer: {
      textAlign: 'center',
      padding: '60px 20px',
    },
    loader: {
      border: '4px solid #DDE8ED',
      borderTop: '4px solid #447793',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      margin: '0 auto 20px',
    },
    
    // Empty State
    emptyState: {
      textAlign: 'center',
      padding: '60px 20px',
      backgroundColor: '#DDE8ED',
      borderRadius: '15px',
      color: '#123249',
    },

    // Error State
    errorContainer: {
      textAlign: 'center',
      padding: '60px 20px',
      backgroundColor: '#fee',
      borderRadius: '15px',
      color: '#c00',
    },

    // Featured badge
    featuredBadge: {
      position: 'absolute',
      top: '10px',
      left: '10px',
      backgroundColor: '#FFD700',
      color: '#123249',
      padding: '4px 10px',
      borderRadius: '20px',
      fontSize: '0.7rem',
      fontWeight: '600',
      zIndex: 2,
    },
  };

  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  if (loading && news.length === 0) {
    return (
      <div style={styles.container}>
        <style>{keyframes}</style>
        <div style={styles.loadingContainer}>
          <div style={styles.loader}></div>
          <p>Loading news...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={styles.errorContainer}>
          <div style={{ fontSize: '3rem', marginBottom: '15px' }}>⚠️</div>
          <h3>Error Loading News</h3>
          <p>{error}</p>
          <button 
            onClick={fetchNews}
            style={{
              padding: '10px 20px',
              backgroundColor: '#447793',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              marginTop: '15px',
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{keyframes}</style>
      
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>📰 Latest News</h1>
        <p style={styles.subtitle}>
          Stay updated with the latest developments in solar energy and renewable power
        </p>
      </div>

      {/* News Grid - 3 Columns */}
      {news.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={{ fontSize: '3rem', marginBottom: '15px' }}>📭</div>
          <h3>No news articles found</h3>
          <p>Check back later for updates</p>
        </div>
      ) : (
        <div style={styles.newsGrid}>
          {news.map((item, index) => (
            <Link
              key={item._id}
              to={`/news/${item._id}`}
              style={{ textDecoration: 'none' }}
            >
              <div
                style={styles.newsCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(68, 119, 147, 0.15)';
                  
                  const img = e.currentTarget.querySelector('.news-image');
                  if (img) img.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 3px 10px rgba(6, 18, 33, 0.08)';
                  
                  const img = e.currentTarget.querySelector('.news-image');
                  if (img) img.style.transform = 'scale(1)';
                }}
              >
                {/* Image */}
                <div style={styles.imageContainer}>
                  {index === 0 && (
                    <div style={styles.featuredBadge}>
                      ⭐ FEATURED
                    </div>
                  )}
                  <div style={styles.dateOverlay}>
                    {formatDate(item.date)}
                  </div>
                  <img
                    src={item.imageUrl || item.image || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=300&fit=crop'}
                    alt={item.title}
                    style={styles.newsImage}
                    className="news-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=300&fit=crop';
                    }}
                  />
                </div>

                {/* Content */}
                <div style={styles.newsContent}>
                  {item.source && (
                    <div style={styles.source}>
                      <span>📰</span>
                      {item.source}
                      {item.sourceLocation && `, ${item.sourceLocation}`}
                    </div>
                  )}
                  
                  <h2 style={styles.newsTitle}>{item.title}</h2>
                  
                  {item.headline && (
                    <div style={styles.headline}>{item.headline}</div>
                  )}
                  
                  <p style={styles.summary}>{item.summary || item.description || 'Click to read more about this news article...'}</p>
                  
                  <div style={styles.metaInfo}>
                    <span>👁️ {item.views || Math.floor(Math.random() * 500) + 100}</span>
                    {item.author && <span>✍️ {item.author.split(' ')[0]}</span>}
                    <span style={styles.readMore}>
                      Read More →
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={styles.pagination}>
          <button
            style={{
              ...styles.pageButton,
              ...(currentPage === 1 ? styles.pageButtonDisabled : {}),
            }}
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
            onMouseEnter={(e) => {
              if (currentPage !== 1) {
                e.currentTarget.style.backgroundColor = '#447793';
                e.currentTarget.style.color = 'white';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== 1) {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = '#123249';
              }
            }}
          >
            ← Previous
          </button>
          
          <span style={{ padding: '10px 20px', color: '#123249' }}>
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            style={{
              ...styles.pageButton,
              ...(currentPage === totalPages ? styles.pageButtonDisabled : {}),
            }}
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
            onMouseEnter={(e) => {
              if (currentPage !== totalPages) {
                e.currentTarget.style.backgroundColor = '#447793';
                e.currentTarget.style.color = 'white';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== totalPages) {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = '#123249';
              }
            }}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default News;